'use es6';

import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import { getIntegrations, createGetIntegrations } from 'reference-resolvers/api/IntegrationsAPI';
export const createIntegrationReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.INTEGRATIONS,
  createFetchData: createGetIntegrations,
  fetchData: getIntegrations
}, options));
export default createIntegrationReferenceResolver();